import { getEnumObject } from '../utilities.js';

export const creatorTypes = {
  FOODICS_USER: 'FoodicsUser',
  MERCHANT_USER: 'MerchantUser',
  SYSTEM: 'System',
};

export default getEnumObject(creatorTypes);
